<!--SchoolIntroduction:学校平台介绍页 2021/12/03 15:44:33 YuAng-->

<template>
  <div class="gw-school-introduction">
    <banner :banners="banners" height="774px"></banner>
    <div class="its-school-part2">
      <p class="its-area-title" style="padding-top: 70px">学校智慧教学全场景，一站式解决</p>
      <img alt="mind" width="1200px" height="720px" :src="require('../../../assets/images/school/school-part2-bg.png')" />
    </div>
    <div class="its-school-part3">
      <p class="its-area-title" style="padding-top: 70px">产品介绍</p>
      <tabs :tabs="tabs" :selected-tab="selectedTab" :offset="48" @change-tab="changeTab"></tabs>
      <p class="its-child-desc">{{selectedChild.desc}}</p>
      <div class="its-child-show">
        <div class="its-child-left" :class="'tab' + selectedTab.id + '' + selectedChild.id">
          <el-carousel ref="carousel" class="its-carousel-child" indicator-position="none">
            <el-carousel-item v-for="i in selectedChild.imgCount" :key="i">
              <img :src="require('../../../assets/images/school/area-part3-' + selectedTab.id + '' + selectedChild.id  + '' + i + '.png')" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-show="selectedTab.children.length > 1" class="its-child-right">
          <ul class="its-child-tabs" :style="{marginTop: (350 - selectedTab.children.length * 50) * 0.5 + 'px'}">
            <li v-for="(tab, i) in selectedTab.children" :key="'tab-' + i" class="its-child-tab" :class="{'active': tab.id === selectedChild.id}" @mouseenter="changeChildTab(tab)">
              <i class="its-icon" :class="tab.icon"></i>{{tab.title}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <connect style="background: white"></connect>
  </div>
</template>
<script>
import Banner from '../home/components/Banner.vue'
import Tabs from '../download/components/Tabs.vue'
import Connect from './components/edition/Connect.vue'
export default {
  components: { Banner, Tabs, Connect },
  name: 'SchoolIntroduction',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      banners: [
        {
          key: 1,
          mainTitle: '以优质数字资源为内核的<br>智慧教学整体解决方案',
          desc: '打造“教、学、管、评、测、研”智慧教学闭环，<br>为教师增效，为学生减负，帮助学校科学管理，<br>让教与学更高效。',
          link: 'Introduction',
          url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-15.mp4',
          playCover: '@/assets/images/home/video_cover.png',
          coverType: 'banner'
        }
      ],
      tabs: [
        {
          id: 1,
          mainTitle: '数字资源',
          children: [
            {
              id: 1,
              title: '优质教学资源',
              desc: '覆盖全学段、全学科、全教材版本、全类型，满足多种教学需求。',
              imgCount: 2,
              icon: 'its-icon-area-11'
            },
            {
              id: 2,
              title: '精品自学资源',
              desc: '精选同步巩固资源、专项突破内容，分层靶向提升。',
              imgCount: 1,
              icon: 'its-icon-area-12'
            },
            {
              id: 3,
              title: '特色学科资源',
              desc: '英语学科特色专题内容，听说读写系统训练，口语、作文智能测评。',
              imgCount: 2,
              icon: 'its-icon-area-13'
            }
          ]
        },
        {
          id: 2,
          mainTitle: '智慧教学',
          children: [
            {
              id: 1,
              title: '轻松备课',
              desc: '资源智能推荐、文件在线编辑、集体协同备课，让备课更轻松、更高效。',
              imgCount: 2,
              icon: 'its-icon-area-12'
            },
            {
              id: 2,
              title: '高效授课',
              desc: '师生互动，随堂检测，即时反馈，打造多元趣味课堂。',
              imgCount: 2,
              icon: 'its-icon-gaoxiaoshouke1'
            },
            {
              id: 3,
              title: '课后训练',
              desc: '科学分层布置，支持自动批改，精准学情分析，灵活高效讲评。',
              imgCount: 2,
              icon: 'its-icon-kehoulianxi'
            },
            {
              id: 4,
              title: '智能考评',
              desc: '基于智能题库，采用“AI算法+老师助力+专家诊断”，满足区域考评需求，生成教师讲评报告、学生个性化考试报告。',
              imgCount: 2,
              icon: 'its-icon-zhinengkaoping'
            },
            {
              id: 5,
              title: '学情诊断',
              desc: '基于全流程数据分析，生成个性化辅导方案，助力精准教学、靶向提升。',
              imgCount: 1,
              icon: 'its-icon-xueqingzhenduan'
            }
          ]
        },
        {
          id: 3,
          mainTitle: '智慧研训',
          children: [
            {
              id: 1,
              title: '智慧研训',
              desc: '提供教师专业培训与研修服务，助力教师基本技能提升与职业发展，帮助教师上好每一堂课。',
              imgCount: 2
            }
          ]
        },
        {
          id: 4,
          mainTitle: '智慧学习',
          children: [
            {
              id: 1,
              title: '智慧学习',
              desc: '提供丰富学生自学资源，教材同步、专项突破，助力学生个性化学习，巩固课堂学习成果。',
              imgCount: 2, 
            }
          ]
        },
        {
          id: 5,
          mainTitle: '智慧管理',
          children: [
            {
              id: 1,
              title: '精准学情',
              desc: '多维度学情数据全面记录、客观分析，辅助教学策略调整。',
              imgCount: 2,
              icon: 'its-icon-jingzhunjiaoxue'
            },
            {
              id: 2,
              title: '教学评价',
              desc: '多维度学生评价体系，助力推进学风、德育、校风建设。',
              imgCount: 1,
              icon: 'its-icon-jiaoxuepingjia'
            },
            {
              id: 3,
              title: '科学管理',
              desc: '纵览全校教学动态，多维度分析，教学评比有据可依，助力学校科学管理。',
              imgCount: 2,
              icon: 'its-icon-kexueguanli'
            },
            {
              id: 4,
              title: '家校互联',
              desc: '家校互通互联，实时了解孩子在校动态，促进家校共育。',
              imgCount: 1,
              icon: 'its-icon-jiaxiaohulian'
            }
          ]
        }
      ],
      selectedTab: { children: [] },
      selectedChild: {}
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.changeTab(this.tabs[0])
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      this.$root.setHeaderBackground()
    },
    changeTab: function (tab) {
      this.selectedTab = tab
      this.changeChildTab(tab.children[0])
    },
    changeChildTab: function (tab) {
      this.selectedChild = tab
      this.$refs.carousel.setActiveItem(0)
    }
  }
}
</script>

<style scoped>
.gw-school-introduction {
  background: #4390ff;
}

.its-school-part2 {
  height: 960px;
  text-align: center;
  background-color: white;
}

.its-area-title {
  font-family: PingFang-SC-Bold;
  font-size: 36px;
  color: #000000;
  margin-bottom: 60px;
}

.its-school-part3 {
  height: 1000px;
  text-align: center;
  background-color: #f8f8f8;
}

.its-school-part3 >>> .its-tabs {
  background-color: #70a6fe;
  margin-top: 0;
}

.its-child-desc {
  padding-top: 120px;
  text-align: left;
  width: 1200px;
  margin: 0 auto 0 auto;
  font-size: 22px;
}

.its-child-show {
  width: 1200px;
  margin: 0 auto 0 auto;
  height: 500px;
}

.its-child-left {
  float: left;
  width: calc(100% - 333px);
  height: 510px;
  background: url(../../../assets/images/its-pc-bg.png) no-repeat;
  background-size: 717px 500px;
  margin-left: 53px;
  margin-top: 32px;
}

.its-child-right {
  float: left;
  width: 240px;
}

.its-child-tabs {
  width: 260px;
  margin-top: 50px;
}

.its-child-tab {
  float: right;
  width: 216px;
  height: 52px;
  line-height: 50px;
  margin-bottom: 25px;
  cursor: pointer;
  text-align: center;
  border-radius: 26px;
  background-color: white;
  color: #50a4f8;
  font-size: 20px;
}

.its-child-tab i {
  font-size: 25px;
  margin-right: 19px;
}

.its-child-tab.active {
  width: 240px;
  height: 62px;
  line-height: 60px;
  background-color: #50a4f8;
  color: white;
  border-radius: 31px;
}

.its-carousel-child {
  margin-top: 18px;
  left: 20px;
  height: 366px;
  width: 672px;
}

.its-child-left.tab12,
.its-child-left.tab41 {
  height: 453px;
  background: url(../../../assets/images/its-pad-bg.png) no-repeat;
  background-size: 768px 453px;
  margin-top: 32px;
}

.its-child-left.tab31,
.its-child-left.tab41 {
  margin-left: 220px;
}

.its-child-left.tab54 {
  background: none;
}

.its-child-left.tab54 .its-carousel-child {
  height: 420px;
}

.its-child-left.tab12 .its-carousel-child,
.its-child-left.tab41 .its-carousel-child {
  height: 406px;
  width: 672px;
  margin-top: 24px;
  left: 56px;
}

.its-carousel-child >>> .el-carousel__container {
  height: 100%;
}

.its-carousel-child img {
  height: 100%;
  width: 100%;
}

.its-carousel-child >>> .el-carousel__arrow {
  display: none;
}
</style>